export default [
  {
    key: 'title',
    label: 'field.title',
    rules: 'required|min:2|max:50',
    type: 'text',
    cols: 12,
    translation: true,
  },
  {
    key: 'description',
    label: 'general.message',
    rules: 'required|min:2|max:1000',
    type: 'textarea',
    rows: '5',
    cols: 12,
  },
  // {
  //   key: 'visible',
  //   label: 'field.visible',
  //   rules: 'required|min:2|max:50',
  //   type: 'checkbox',
  // },
]
